import { FCX, getFormattedThousand } from "@datassential/platform-ui-lib";
import { Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import useFoodProfileInsightsSummary from "@apiHooks/useFoodProfileInsightsSummary";
import InsightsSummaryCard from "@components/InsightsSummaryCard/InsightsSummaryCard";
import { buildFilteredChainsUrl } from "@pages/NewTopChains/PlacesFoodsTabs/PlacesFoodsTabs.helpers";
import "./FoodInsightsSummary.scss";

interface Props {
    word: string;
}

const FoodInsightsSummary: FCX<Props> = ({ word }) => {
    const { data: { chainsCount, bullets }, isLoading } = useFoodProfileInsightsSummary(word);

    // Empty, 204 and failed responses all hide the section, as on Category Profile.
    if (!isLoading && bullets.length === 0) return null;

    const chainsLink = !isLoading && chainsCount > 0 && (
        <>
            on the menu at&nbsp;
            <Link
                className="FoodInsightsSummary__chains-link"
                to={buildFilteredChainsUrl(word)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="buttonFoodInsightsSummaryChainsLink"
            >
                <b>{getFormattedThousand(chainsCount)} chains</b>
                <FiExternalLink className="FoodInsightsSummary__chains-link-icon"/>
            </Link>
        </>
    );

    return (
        <InsightsSummaryCard
            className="FoodInsightsSummary"
            testId="blockFoodInsightsSummary"
            title="Insights Summary"
            headerExtra={chainsLink}
            bullets={bullets}
            isLoading={isLoading}
        />
    );
};

/** Mounts the section only for a food term, so no request is sent without one. */
const FoodInsightsSummarySection: FCX<Props> = ({ word }) => {
    if (!word) return null;

    return <FoodInsightsSummary word={word}/>;
};

export default FoodInsightsSummarySection;
